export default __webpack_public_path__ + "static/media/sistemab3.bc995e4c.jpg";